import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const heroImages = ['https://images.unsplash.com/photo-1581351721010-8cf859cb14a4?q=80&w=2940&auto=format&fit=crop', 'https://images.unsplash.com/photo-1613490493576-7fde63acd811?q=80&w=2940&auto=format&fit=crop', 'https://images.unsplash.com/photo-1556909172-54557c7e4fb7?q=80&w=2940&auto=format&fit=crop'];
export function Hero() {
  const [currentImage, setCurrentImage] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage(prev => (prev + 1) % heroImages.length);
    }, 6000);
    return () => clearInterval(interval);
  }, []);
  return <section className="relative h-screen w-full flex items-center justify-center overflow-hidden" data-id="element-180">
      {/* Rotating Background Images */}
      <AnimatePresence mode="sync" data-id="element-181">
        {heroImages.map((image, index) => index === currentImage && <motion.div key={image} initial={{
        opacity: 0,
        scale: 1.05
      }} animate={{
        opacity: 1,
        scale: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 1.5,
        ease: 'easeInOut'
      }} className="absolute inset-0 w-full h-full bg-cover bg-center bg-no-repeat" style={{
        backgroundImage: `url("${image}")`
      }} data-id="element-182" />)}
      </AnimatePresence>

      {/* Dark Overlay (always visible) */}
      <div className="absolute inset-0 bg-charcoal/40 mix-blend-multiply z-[1]" data-id="element-183"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-charcoal/60 via-transparent to-charcoal/80 z-[1]" data-id="element-184"></div>

      {/* Content */}
      <div className="relative z-10 text-center px-6 max-w-4xl mx-auto mt-20" data-id="element-185">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.2
      }} data-id="element-186">
          <span className="text-gold uppercase tracking-[0.3em] text-sm md:text-base font-medium mb-6 block" data-id="element-187">
            Welcome to Las Vegas
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.4
      }} className="text-5xl md:text-7xl lg:text-8xl text-white font-serif mb-8 leading-tight" data-id="element-188">
          Luxury Living in <br className="hidden md:block" data-id="element-189" />
          <span className="italic font-light" data-id="element-190">Las Vegas</span>
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.6
      }} className="text-lg md:text-xl text-white/90 font-light max-w-2xl mx-auto mb-12" data-id="element-191">
          Discover unparalleled elegance and exclusive estates in Nevada's most
          prestigious communities.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 1,
        delay: 0.8
      }} data-id="element-192">
          <a href="#listings" className="inline-block bg-gold text-white px-10 py-4 uppercase tracking-widest text-sm hover:bg-gold-dark transition-colors duration-300" data-id="element-193">
            Explore Properties
          </a>
        </motion.div>
      </div>

      {/* Image Indicators */}
      <div className="absolute bottom-24 left-1/2 -translate-x-1/2 z-10 flex gap-3" data-id="element-194">
        {heroImages.map((_, index) => <button key={index} onClick={() => setCurrentImage(index)} className={`h-[2px] transition-all duration-500 ${index === currentImage ? 'w-10 bg-gold' : 'w-6 bg-white/40 hover:bg-white/60'}`} data-id="element-195" />)}
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      duration: 1,
      delay: 1.5
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 z-10" data-id="element-196">
        <span className="text-white/60 text-xs uppercase tracking-widest" data-id="element-197">
          Scroll
        </span>
        <div className="w-[1px] h-12 bg-white/30 relative overflow-hidden" data-id="element-198">
          <motion.div className="w-full h-1/2 bg-white absolute top-0" animate={{
          top: ['-50%', '100%']
        }} transition={{
          duration: 1.5,
          repeat: Infinity,
          ease: 'linear'
        }} data-id="element-199" />
        </div>
      </motion.div>
    </section>;
}